import { PATH } from './constants/router'
import AutomatedTrafficFineNotificationAuthentication from './page/AutoTrafficFineNotificationAuthentication'
import AutomatedTrafficFineNotificationIntroduce from './page/AutoTrafficFineNotificationIntroduce'
import AutomatedTrafficFineNotificationPayment from './page/AutoTrafficFineNotificationPayment'
import AutomatedTrafficFineNotificationServices from './page/AutoTrafficFineNotificationServices'
import AutomatedTrafficFineNotificationSuccess from './page/AutoTrafficFineNotificationSuccess'
import AutomatedTrafficFineNotificationVehicles from './page/AutoTrafficFineNotificationVehicles'
import TrafficFineCheckResult from './page/AutoTrafficFineNotificationCheckResult'
import TrafficFineLookup from './page/AutoTrafficFineNotificationLookup'
import TrafficFinePackageInfo from './page/AutoTrafficFineNotificationPackageInfo'
import TaxCDSIntroduce from './page/TaxCDSIntroduce'
import TaxCDSSmartAssistantInfo from './page/TaxCDSSmartAssistantInfo'
import AutoTrafficFineNotificationPaymentSuccess from './page/AutoTrafficFineNotificationPaymentSuccess'
import LoginByToken from './page/LoginByToken'
import { DEFAULT_HOME_PAGE, getDefaultHomePage } from './constants/homePage'


const HOME_PAGE_COMPONENT = {
  [DEFAULT_HOME_PAGE.TRAFFIC_FINE_LOOKUP]: TrafficFineLookup,
  [DEFAULT_HOME_PAGE.TAX_CDS_INTRODUCE]: TaxCDSIntroduce
}

const DEFAULT_HOME_COMPONENT = HOME_PAGE_COMPONENT[getDefaultHomePage()] || TrafficFineLookup

export const ROUTERS = {
  home: {
    path: PATH.HOME,
    component: DEFAULT_HOME_COMPONENT
  },
  loginByToken: {
    path: PATH.LOGIN_BY_TOKEN,
    component: LoginByToken
  },

  taxCdsIntroduce: {
    path: PATH.TAX_CDS_INTRODUCE,
    component: TaxCDSIntroduce
  },

  taxCdsSmartAssistant: {
    path: PATH.TAX_CDS_SMART_ASSISTANT,
    component: AutomatedTrafficFineNotificationServices
  },
  taxCdsSmartAssistantInfo: {
    path: PATH.TAX_CDS_SMART_ASSISTANT_INFO,
    component: TaxCDSSmartAssistantInfo
  },
  automatedTrafficFineNotificationServices: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES,
    component: AutomatedTrafficFineNotificationServices
  },
  trafficFineLookup: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP,
    component: TrafficFineLookup
  },
  trafficFineCheckResult: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_CHECK_RESULT,
    component: TrafficFineCheckResult
  },
  trafficFinePackageInfo: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PACKAGE_INFO,
    component: TrafficFinePackageInfo
  },
  automatedTrafficFineNotificationVehicles: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_VEHICLES,
    component: AutomatedTrafficFineNotificationVehicles
  },
  automatedTrafficFineNotificationPayment: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT,
    component: AutomatedTrafficFineNotificationPayment
  },
  autoTrafficFineNotificationPaymentSuccess: {
  path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT_SUCCESS,
  component: AutoTrafficFineNotificationPaymentSuccess
},
  automatedTrafficFineNotificationIntroduce: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_INTRODUCE,
    component: AutomatedTrafficFineNotificationIntroduce
  },
  automatedTrafficFineNotificationSuccess: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS,
    component: AutomatedTrafficFineNotificationSuccess
  },
  automatedTrafficFineNotificationAuthentication: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_AUTHENTICATION,
    component: AutomatedTrafficFineNotificationAuthentication
  }
}